module.exports = __webpack_public_path__ + "static/img/GL-6-A智能安全帽使用说明书-2.322e667.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/GL-6-A智能安全帽使用说明书-2.jpg
// module id = mAnm
// module chunks = 0